export default __webpack_public_path__ + "static/media/BrunoSylin.8177796a.webp";